import type { IPlace } from "@bbj-types/address";
import { AutocompletePlaces } from "@inputs/autocomplete/AutocompletePlacesUniq";
import { Chip, autocompleteClasses } from "@mui/material";
import { Stack, TextField } from "@mui/material";
import type { Dispatch, SetStateAction, SyntheticEvent } from "react";

interface ICandidatePlaceFilterProps {
  innerPlaces: IPlace[];
  setInnerPlaces: Dispatch<SetStateAction<IPlace[]>>;
}
export const CandidatePlaceFilter = ({ innerPlaces, setInnerPlaces }: ICandidatePlaceFilterProps) => {
  const handleChange = (_: SyntheticEvent<Element, Event>, value: IPlace[]) => {
    setInnerPlaces([...value]);
  };

  return (
    <Stack>
      <AutocompletePlaces
        value={innerPlaces}
        multiple
        size="small"
        onChange={handleChange}
        renderInput={(params) => (
          <TextField {...params} label="Lieu de résidence " size="small" sx={{ width: "200px" }} />
        )}
        renderValue={(values, getTagProps) =>
          values.map((value, index) => (
            <Chip
              color="yellow"
              label={value.placeLabel}
              size="small"
              sx={{ [`&.${autocompleteClasses.tag}`]: { mt: "1px", mb: 0 } }}
              {...getTagProps({ index })}
              key={value._id}
            />
          ))
        }
        limitTags={3}
      />
    </Stack>
  );
};
